import { FC } from 'react';
import styled from '@emotion/styled';
import { TooltipRenderProps } from 'react-joyride';
type TooltipComponent = FC<TooltipRenderProps>;
const TooltipContainer = styled.div`
  position: relative;
  border: ${({
  theme
}) => `3px solid ${theme.color.surfaceBright}`};
  border-radius: 16px;
  background-color: ${({
  theme
}) => theme.color.surfaceDeep};
  padding: 12px 16px;
  width: max-content;
  max-width: 400px;
`;
const TooltipMessage = styled.span`
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  color: ${({
  theme
}) => theme.color.contentBright};
  white-space: pre-wrap;
`;
const PointerImage = styled.img<{
  placement?: TooltipRenderProps['step']['placement'];
}>`
  width: 56px;
  height: 56px;
  position: absolute;

  ${({
  placement
}) => {
  switch (placement) {
    case 'bottom-start':
      return `
          top: -45px;
          left: 16px;
        `;
    case 'bottom-end':
      return `
          top: -45px;
          right: -16px;
        `;
    case 'left':
      return `
            transform: rotate(90deg);
            bottom: 0;
            right: -48px;
          `;
    case 'right':
      return `
          transform: rotate(90deg) scaleY(-1);
          bottom: 0;
          left: -48px;
        `;
    case 'top':
      return `
          transform: rotate(180deg);
          left: 0;
          bottom: -49px;
        `;
    default:
      return '';
  }
}}
`;
const TutorialTooltip: TooltipComponent = ({
  step,
  tooltipProps
}) => {
  return <TooltipContainer className='tooltip__body' {...tooltipProps} data-sentry-element="TooltipContainer" data-sentry-component="TutorialTooltip" data-sentry-source-file="TutorialTooltip.tsx">
      <TooltipMessage data-sentry-element="TooltipMessage" data-sentry-source-file="TutorialTooltip.tsx">{step.content}</TooltipMessage>
      <PointerImage src='/images/imgPickMatch.webp' alt='pointer' placement={step.placement} data-sentry-element="PointerImage" data-sentry-source-file="TutorialTooltip.tsx" />
    </TooltipContainer>;
};
export default TutorialTooltip;